import { getLabel } from "../../../hooks/use-labels";
import { publicSliceActions } from "./public-Slice";

const convertCountriesToOptions = (countries) => {
  const options = [];
  countries.forEach((country) => {
    options.push({
      label: country.name,
      value: country.code,
      key: country.code,
      ...country,
    });
  });

  return options;
};

export const setAllCurrencies = (currencies) => {
  return (dispatch) => {
    dispatch(publicSliceActions.setAllCurrencies(currencies));
  };
};

export const setAllCountries = (countries) => {
  return (dispatch) => {
    const countryOptions = convertCountriesToOptions(countries);
    dispatch(publicSliceActions.setCountryOptions(countryOptions));
    dispatch(publicSliceActions.setAllCountries(countries));
  };
};

const prepareTypeOptions = (options) => {
  return options.map((item) => ({
    ...item,
    label: getLabel(item.code) || item.defaultTitle,
    value: item.id,
    key: item.id,
  }));
};

export const setContainerTypes = (fuelTypes) => {
  return (dispatch) =>
    dispatch(publicSliceActions.setContainerTypes(prepareTypeOptions(fuelTypes)));
};

export const setFuelTypes = (fuelTypes) => {
  return (dispatch) =>
    dispatch(publicSliceActions.setFuelTypes(prepareTypeOptions(fuelTypes)));
};

export const setContainerOptions = (containerOptions) => {
  return (dispatch) =>
    dispatch(
      publicSliceActions.setContainerOptions(
        prepareTypeOptions(containerOptions)
      )
    );
};

export const setContainerMaterials = (containerMaterials) => {
  return (dispatch) =>
    dispatch(
      publicSliceActions.setContinerMaterials(
        prepareTypeOptions(containerMaterials)
      )
    );
};
